module.exports = __webpack_public_path__ + "img/totalsection.dd2f989a.svg";